var _path, _g, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    fill: "none",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "m1ntuu3uVwa",
    width: 368,
    height: 176,
    x: 31,
    y: 204,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M398.17 204.969H31.83V379.5H224v-85h36V240h100v54.5h35v85h3.17z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m1ntuu3uVwa)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffce48",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M55 318.545C55 260.807 101.807 214 159.545 214h80.909C298.193 214 345 260.807 345 318.545V349H55z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffce48",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12,
    d: "M200.5 180c37.279 0 67.5-30.221 67.5-67.5 0-37.28-30.221-67.5-67.5-67.5S133 75.22 133 112.5s30.221 67.5 67.5 67.5m59.5 60h100v140H260zm0 55h-35v85h35m100-85h35v85h-35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffce48",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12,
    d: "M330 380v-50h-40v50m20-115v40m20-20h-40"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.db064ebaf24e6cfc8c3579d37337ff83.svg";
export { ForwardRef as ReactComponent };